import { useTranslations } from 'use-intl';

interface Question {
  id: string;
}

interface Props {
  currentIndex: number;
  total: number;
  questions?: Question[];
  onQuestionClick?: (questionId: string) => void;
}

export default function SurveyAiFormsProgressDots({
  currentIndex,
  total,
  questions,
  onQuestionClick,
}: Props) {
  const t = useTranslations('AIForms');

  const handleClick = (index: number) => {
    if (questions && onQuestionClick && questions[index]) {
      onQuestionClick(questions[index].id);
    }
  };

  return (
    <div
      data-test='progress-dots'
      className='mt-8 flex items-center justify-center gap-1'
    >
      {Array.from({ length: total }).map((_, index) => (
        <button
          type='button'
          key={index}
          onClick={() => handleClick(index)}
          disabled={!questions || !onQuestionClick}
          data-active={index === currentIndex}
          className='h-1.5 rounded-sm transition-all enabled:cursor-pointer hover:enabled:opacity-80 disabled:cursor-default data-[active=false]:w-1.5 data-[active=false]:bg-gray-200 data-[active=true]:w-4 data-[active=true]:bg-(--brand-primary) data-[active=true]:shadow-lg'
          aria-label={t('aria.goToQuestion', { number: index + 1 })}
          data-test='progress-dot'
        />
      ))}
    </div>
  );
}
